import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import accessCheckPromise from "../../../../utils/accessCheck";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import AuthorizationError from "../AuthorizationError";
import { Tabs, Typography } from "antd";
import Chats from "./components/Chats";
import Reports from "./components/Reports";

const { Title } = Typography;

const AIReportingInsightsContainer = () => {
  const dispatch = useDispatch();
  const [access, setAccess] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);

  const tabChange = (key) => {
    setActiveTab(key);
  };

  const tabItems = [
    {
      key: "1",
      label: "Chats",
      children: <Chats />,
    },
    {
      key: "2",
      label: "Report Subscribers",
      children: <Reports />,
    },
  ];

  if (!access) {
    return <AuthorizationError />;
  }

  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          padding: "0px 20px",
        }}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={tabChange}
          items={tabItems}
        />
      </div>
    </div>
  );
};

export default AIReportingInsightsContainer;
